"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("react");
var react_2 = require("@emotion/react");
var rc_slider_1 = __importDefault(require("rc-slider"));
var styles_1 = require("./styles");
var HandleTooltip_1 = __importDefault(require("./HandleTooltip"));
var layout_1 = require("../../layout");
var Input_1 = __importDefault(require("../Input"));
function Slider(props) {
    var range = props.range, showText = props.showText, _a = props.valueSuffix, valueSuffix = _a === void 0 ? '%' : _a;
    var handleRender = function (node, _a) {
        var value = _a.value;
        return (react_2.jsx(HandleTooltip_1.default, __assign({ placement: showText ? 'bottom' : 'top', value: value }, (showText ? { visible: true } : {}), { getTooltipContainer: function () { return document.querySelector('#slider-container'); }, valueSuffix: valueSuffix }), node));
    };
    var theme = react_2.useTheme();
    var themeStyles = react_1.useMemo(function () { return [
        styles_1.sliderStyles(theme),
        styles_1.tooltipStyles(theme),
    ]; }, [theme]);
    var handleOnChange = function (value) {
        var change = props.onChange;
        change(value ? Number(parseInt(value)) : undefined);
    };
    return (react_2.jsx(layout_1.Flex, { css: __spreadArrays([styles_1.styles.container], themeStyles), id: "slider-container" },
        react_2.jsx(rc_slider_1.default, __assign({ min: props.min, max: props.max, range: props.range, value: props.value, onChange: props.onChange, allowCross: false, handleRender: handleRender }, props)),
        !range && (react_2.jsx(Input_1.default, { onChange: handleOnChange, value: props.value ? String(props.value) : '', size: "large", css: styles_1.styles.input, disabled: props.disabled, after: react_2.jsx("span", { css: styles_1.styles.percentageSymbol }, valueSuffix) }))));
}
exports.default = Slider;
